import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import NotificationSegmentServices from "./NotificationSegment.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getNotificationSegment = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_NOTIFICATION_SEGMENT,
      payload: true,
    });
    const resp = await NotificationSegmentServices.getNotificationSegment(filters);
    dispatch({
      type: actions.GET_NOTIFICATION_SEGMENT,
      payload: {
        notificationSegments: resp.data.data,
        notificationSegmentsLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_SEGMENT_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.NOTIFICATION_SEGMENT_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_SEGMENT,
      payload: false,
    });
  }
};

export const getNotificationSegmentById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_NOTIFICATION_SEGMENT,
      payload: true,
    });
    const resp = await NotificationSegmentServices.getNotificationSegmentByID(id);
    dispatch({
      type: actions.GET_NOTIFICATION_SEGMENT,
      payload: {
        notificationSegments: resp.data,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_SEGMENT_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.NOTIFICATION_SEGMENT_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_SEGMENT,
      payload: false,
    });
  }
};

export const saveNotificationSegment =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_SEGMENT,
        payload: true,
      });
      const resp = await NotificationSegmentServices.saveNotificationSegment(data);
      const { notificationSegments, notificationSegmentsLength } = getState().notificationSegment;
      const _notificationSegments = [...notificationSegments, resp.data];
      dispatch({
        type: actions.GET_NOTIFICATION_SEGMENT,
        payload: {
          notificationSegments: _notificationSegments,
          notificationSegmentsLength: notificationSegmentsLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_NOTIFICATION_SEGMENT,
        payload: false,
      });
    }
  };

export const editNotificationSegment =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_NOTIFICATION_SEGMENT,
        payload: true,
      });
      const resp = await NotificationSegmentServices.editNotificationSegment(id, data);
      const { notificationSegments, notificationSegmentsLength } = getState().notificationSegment;
      let _notificationSegments = [...notificationSegments]
      _notificationSegments[index] = resp.data;
      dispatch({
        type: actions.GET_NOTIFICATION_SEGMENT,
        payload: {
          notificationSegments: _notificationSegments,
          notificationSegmentsLength: notificationSegmentsLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_NOTIFICATION_SEGMENT,
        payload: false,
      });
    }
  };

export const deleteNotificationSegment = (id, index) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: actions.LOADING_NOTIFICATION_SEGMENT,
      payload: true,
    });
    await NotificationSegmentServices.deleteNotificationSegment(id);
    const { notificationSegments, notificationSegmentsLength } = getState().notificationSegment;
    let _notificationSegments = [...notificationSegments]
    _notificationSegments.splice(index, 1);
    dispatch({
      type: actions.GET_NOTIFICATION_SEGMENT,
      payload: {
        notificationSegments: _notificationSegments,
        notificationSegmentsLength: notificationSegmentsLength - 1,
      },
    });
    dispatch({
      type: actions.NOTIFICATION_SEGMENT_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;                         
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.NOTIFICATION_SEGMENT_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_NOTIFICATION_SEGMENT,
      payload: false,
    });
  }
};
